export enum PaymentFlow {
	CARD = "card",
	SBP = "sbp",
	AGENT = "total",
}

export interface PaymentFlowRange {
	min: number;
	max: number;
}

export interface PaymentFlowRanges {
	card: PaymentFlowRange | null;
	sbp: PaymentFlowRange | null;
	total: PaymentFlowRange | null;
}
